module.exports = __webpack_public_path__ + "img/c2-2.fbbbf437.png";